import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";

const CheckBoxOutlineBlankIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 20 20"
      sx={{
        fontSize: "inherit",
        fill: "none",
        ...sx,
      }}
      {...otherProps}
    >
      <rect x="2" y="2" width="16" height="16" rx="2" fill="white" />
      <rect
        x="2.5"
        y="2.5"
        width="15"
        height="15"
        rx="1.5"
        stroke="currentColor"
      />
    </SvgIcon>
  );
};
export default memo(CheckBoxOutlineBlankIcon);
